var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',_vm._l((_vm.enabledModules),function(em,i){return _c(_vm.getModule(em),{key:'component-' + i,tag:"component",attrs:{"documentData":_vm.documentData,"error":_vm.error}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }